import { render, staticRenderFns } from "../templates/normal_fcont_169.html?vue&type=template&id=212b0d4a&scoped=true&"
import script from "./normal_fcont_169.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_169.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b0d4a",
  null
  
)

export default component.exports